/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scale a common molecular-biology buffer to any volume. Pick a recipe and enter the volume you want — the ingredient amounts are worked out for you.`)
};

const es_buf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escala un buffer común de biología molecular a cualquier volumen. Elige una receta e introduce el volumen deseado — las cantidades de ingredientes se calculan por ti.`)
};

const de_buf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skalieren Sie einen gängigen molekularbiologischen Puffer auf beliebiges Volumen. Wählen Sie ein Rezept und geben Sie das gewünschte Volumen ein — die Zutatenmengen werden für Sie berechnet.`)
};

const nl_buf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schaal een veelgebruikte moleculair-biologische buffer naar elk volume. Kies een recept en voer het gewenste volume in — de ingrediënthoeveelheden worden voor u berekend.`)
};

const fr_buf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adaptez un tampon courant de biologie moléculaire à n'importe quel volume. Choisissez une recette et entrez le volume voulu — les quantités d'ingrédients sont calculées pour vous.`)
};

const it_buf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scala un buffer comune di biologia molecolare a qualsiasi volume. Scegli una ricetta e inserisci il volume desiderato — le quantità degli ingredienti vengono calcolate per te.`)
};

const pt_br2_buf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione um tampão comum de biologia molecular para qualquer volume. Escolha uma receita e informe o volume desejado — as quantidades de ingredientes são calculadas para você.`)
};

const pt_buf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escale um tampão comum de biologia molecular para qualquer volume. Escolha uma receita e introduza o volume pretendido — as quantidades dos ingredientes são calculadas automaticamente.`)
};

const ja_buf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般的な分子生物学バッファーを任意の量にスケーリングします。レシピを選び、作りたい量を入力すると試薬量が自動で計算されます。`)
};

const zh_buf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将常见分子生物学缓冲液按任意体积放大。选择配方并输入所需体积——成分用量会自动为你计算。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_intro", locale)
	if (locale === "en") return en_buf_intro(inputs)
	if (locale === "es") return es_buf_intro(inputs)
	if (locale === "de") return de_buf_intro(inputs)
	if (locale === "nl") return nl_buf_intro(inputs)
	if (locale === "fr") return fr_buf_intro(inputs)
	if (locale === "it") return it_buf_intro(inputs)
	if (locale === "pt-BR") return pt_br2_buf_intro(inputs)
	if (locale === "pt") return pt_buf_intro(inputs)
	if (locale === "ja") return ja_buf_intro(inputs)
	return zh_buf_intro(inputs)
};